export var defaultRows = {
    offset: 0,
    limit: 100,
};
export function setRowsDefaultOffset(rowsOffset) {
    defaultRows.offset = rowsOffset;
}
export function setRowsDefaultLimit(rowsLimit) {
    defaultRows.limit = rowsLimit;
}
